import { ReactElement } from "react";
import { ChatbotTool } from "./ChatbotTool";
import { toolConfigurations } from "./ToolConfig";

interface ToolContainerProps {
  selectedTool: string | null;
  setSelectedTool: (tool: string | null) => void;
  className?: string;
  isDark?: boolean;
}

export function ToolContainer({
  selectedTool,
  setSelectedTool,
  className,
  isDark,
}: ToolContainerProps): ReactElement {

  // Look up the configuration for the currently selected tool
  const currentConfig = selectedTool ? toolConfigurations[selectedTool] : null;

  return (
    <div className={className}>
      {selectedTool && currentConfig && (
        <ChatbotTool
          setSelectedTool={setSelectedTool}
          isDark={isDark}
          config={currentConfig}
          /*
           * KEY: Using the tool's title as the React key forces a FULL
           * unmount/remount when switching between tools. This means all
           * useState hooks reset to their initial values, all useEffect
           * cleanup functions run, and the new component mounts fresh.
           * This provides an additional layer of defense against state bleed
           * on top of the explicit tool_id validation in the useEffect.
           */
          key={currentConfig.title}
        />
      )}
    </div>
  );
}